/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/*****components***/
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
/*custom components*/
import PageLoading from "../../components/PageLoading";
import Modal from "../../components/ModalV2";
import Form from "../../components/Form";
import Card from "../../components/Card";
import Caracol from "../../components/Caracol";
import Slider from "../../components/Slider";
import SliderImage from "../../components/SliderImage";
import Text from "../../components/Text";
import Button from "../../components/Button";
import Image from "../../components/Image";
import Video from "../../components/Video";
import EventMessage from "../../components/EventMessage";
import { setApiToken } from "../../common/api";
import { setApiTokenV2 } from "../../common/apiV2";
import Login from "../../components/Login";
import Map from "../../components/Map";
import LoginG from "../login/loginG";
import EventProductsInfo from "../../components/EventProductsInfo";
import {
  getS3PublicFile
} from "../../common/functionsV2";
import {
  toast,
  MDBAlert,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBBtn,
} from "mdbreact";
import ico_login from "../../assets/images/ico_login.svg";

/*functions*/
import {
  updateEventList,
  manageCart,
  getImageExtension,
  getCookie,
  setCookie,
  shareEvent,
  formatPathName,
  getImagePath,
  managepagination,
  getRenderObj,
  login,
  getDefValues,
  getLanguage,
  managesort,
  findObjName,
  getSyncStoresInfo,
  find,
  callApiV2,
  getLoginInfo,
  changeHandler,
  changeHandlerManager,
  toggleModalManager,
  loadPageV2,
  mergeFormData,
  validateForm,
  showError,
  showMessage,
  showWarning,
  parseFormData,
} from "../../common/functions";

import { BitlyClient } from "bitly-react";
import { withScriptjs } from "react-google-maps";
var windowWidth = window.innerWidth;
const GoogleMapsAPI = process.env.REACT_APP_API_KEY_GMAP;
class page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      lockform: true,
      storeStatus: "NO",
      messages: [],
      noEvents: false,
      needLogin: true,
      formstep: 1,
      isLoading2: false,
      eventmessage: "",
      eventname: "",
      //city: "La Paz",
      skus: [],
      orders: [],
      skuToAdd: "",
      eventimage: "",
      mainClass: "page-wrapper",
      redirectProductDetails: false,
      selectedProductID: 0,
      externalOrderFormConfig: {},
      externalOrderFormData: {},
      selectedPath: "",
      selectedCategory: "",
      modal2: false,
      modal1: false,
      isCopied: false,
      shareUrl: "",
      eventInfo: {},
      eventListInfo: { products: [], needCommit: false },
      formData: {
        email: {
          label: getDefValues().emailLabel,
          value: "",
          type: "INPUT",
          validationtype: "email",
        },
        password: {
          label: getDefValues().passwordLabel,
          value: "",
          type: "PASSWORD",
          validationtype: "PASSWORD",
        },
      },
      latitude: -16.5337955,
      longitude: -68.0865515,
      address: "",
      city: "",
      showEvents: false,
      externalOrder: false,
      externalOrderId: 0,
    };
  }

  showExternalOrder = (event) => {
    if (this.state.externalOrder) {
      this.setState({ ...this.state, externalOrder: false });
    } else {
      this.setState({ ...this.state, externalOrder: true });
    }
  };
  /*loading data*/
  componentDidMount = async () => {
    try {
      this.props.hideCart();
      setApiToken(getLoginInfo().keyToken);
      setApiTokenV2(getLoginInfo().keyToken);
      const urlParams = new URLSearchParams(window.location.search);
      let accessKey = urlParams.get("accesskey");

      if (!accessKey) {
        accessKey = getCookie(
          process.env.REACT_APP_ORG_NAME + "_eventAccessKey"
        );
      }

      var scrollCheck = window.scrollY;
      var resumeStyle = {
        position: "relative",
        rigth: "0px",
        top: scrollCheck,
        background: "#fff",
        zIndex: "10",
      };
      if (window.innerWidth <= 799) {
        resumeStyle = {};
      }
      this.setState({ resumeStyle: resumeStyle, scrollCheck: scrollCheck });

      var resp1;
      var resp2;
      var eventid = 0;
      var login = {};
      var noToken = true;
      var token;
      var selectedEventId = 0;
      var formstep = 1;

      var eventCookieId = getCookie(
        process.env.REACT_APP_ORG_NAME + "_eventId"
      );
      var haveParam = false;

      var eventToken = getCookie(
        process.env.REACT_APP_ORG_NAME + "_eventToken"
      );
      //console.log("eventToken", this.props.match, eventToken)
      if (this.props.match.params.key || eventToken) {
        if (this.props?.match?.params?.key?.indexOf("addProducts") >= 0) {
          selectedEventId = parseInt(
            this.props.match.params.key.replace("addProducts_", "")
          );
          formstep = 2;
          login = getLoginInfo();
        } else {
          console.log("es token admin")
          haveParam = true;
          token = this.props.match?.params?.key;
          if (token) {
            //console.log("token de la url, set cookie")
            setCookie(
              process.env.REACT_APP_ORG_NAME + "_eventToken",
              token,
              0.5
            );
          } else {
            //console.log("token de la cookie", eventToken)
            token = eventToken;
          }

          resp1 = await callApiV2("frontend", "getCustomerEventByToken", {
            token: token,
            accessKey: accessKey
          });

          if (resp1.success) {
            let tokenInfo = {
              ...resp1.response.datos_personales[0],
              userId: resp1.response.customerid
            }
            console.log("tokenInfo", tokenInfo)
            this.setState({ ...this.state, token: tokenInfo });
            login = tokenInfo;
            eventid = Number(resp1.response.eventcode)
          }
          noToken = false;
          formstep = 2;
        }
      }

      if (eventCookieId && !haveParam) {
        if (
          eventCookieId != "0" &&
          eventCookieId != "null" &&
          eventCookieId != ""
        ) {
          selectedEventId = parseInt(eventCookieId);
          /*
            let moreEvents = false;
            login = getLoginInfo()
            let resp1 = await callApi ( "frontend","getCustomerEventsByUserId", {userid:login.userId } )
            if (resp1.response.length>1){				 
              moreEvents=true											
            }
          */
          formstep = 2;
        }
      }

      try {
        if (window.location.search.indexOf("step=info") >= 0) {
          formstep = 1;
        } else if (window.location.search.indexOf("step=list") >= 0) {
          formstep = 2;
        }
      } catch (Ex) {
        console.log("EX", Ex);
      }

      this.setState({ formstep: formstep });

      var showEvents = false;
      var moreEvents = false;
      var events = [];
      if (noToken) {
        console.log("noToken")
        login = getLoginInfo();
        resp1 = await callApiV2("frontend", "getCustomerEventsByUserId", {
          id: login.userId,

        });
        //console.log("resp1", resp1)

        if (resp1.response.length > 1) {
          moreEvents = true;
        }

        if (selectedEventId > 0) {
          eventid = selectedEventId;

          for (let e in resp1.response) {
            let eventD = resp1.response[e];
            eventD["EVENTINFO"] = {
              "city": eventD.city,
              "message": eventD.message,
              "directions": eventD.directions,
              "additionalshippinginstructions": eventD.additionalshippinginstructions,
              "eventname": eventD.eventname,
            }
            events.push(eventD);
          }
        } else {
          if (resp1.response.length > 1) {
            showEvents = true;
            for (let e in resp1.response) {
              let eventD = resp1.response[e];
              eventD["EVENTINFO"] = {
                "city": eventD.city,
                "message": eventD.message,
                "directions": eventD.directions,
                "additionalshippinginstructions": eventD.additionalshippinginstructions,
                "eventname": eventD.eventname,
              }
              events.push(eventD);
            }
          }

          //console.log("events", events)

          if (resp1.response.length > 0) {
            eventid = resp1.response[0].eventcode;
          }
        }
      }
      //console.log("eventid", eventid)
      resp2 = await callApiV2("frontend", "getCustomerEventById", {
        id: eventid,
        accessKey: accessKey
      });

      if (login.userId) {
        //var finalFoldername=foldername
        var layoutFile = "createEventForm_" + getLanguage();

        const respForm = await getS3PublicFile(
          process.env.REACT_APP_S3FILES +
          `/public/files/createEventForm.json`
        );

        if (resp2.success) {
          let resp3 = {}

          if (resp2.response.productos) {
            resp3 = await callApiV2("customer", "getProductByIds", {
              productIds: resp2.response.productos,
              accessKey: accessKey
            });
            //console.log("Resp3", resp3)
          }

          let storesInfo = getSyncStoresInfo();
          if (storesInfo.selectedStoreId !== resp2.response.storeid) {
            this.props.setStoreOff(resp2.response.storeid);
          }

          const form = await getS3PublicFile(
            process.env.REACT_APP_S3FILES +
            `/public/files/setExternalOrderForm.json`
          );
          let rendegObj = await getRenderObj(
            form[0],
            null,
            null,
            null,
            null,
            null,
            null,
            null
          );
          let externalOrderFormData = rendegObj.curdata.data;
          let externalOrderFormConfig = rendegObj.curdata.config;

          let qty = 0;
          // eslint-disable-next-line array-callback-return
          if (resp2.response.productos) {
            resp2.response.productos.map(function (item) {
              qty = qty + item.quantity;
            });
          }
          //this.props.setEventMode(eventid, resp2.EVENT.EVENTINFO.eventname, 'addEventList', qty)
          if (!moreEvents) {
            await this.props.setEventMode(
              eventid,
              resp2.response.eventname,
              "addEventList",
              qty
            );
          }

          //let resp4 = await callApi  ( "admin","getCustomerById"   , {   customerid: login.userId } )
          //this.setState({...this.state,  userDataInfo : resp4.USER, userAddInfo: resp4.ADDRESS });

          var _city = (resp2.response.city).toString();
          var city = "";

          if (_city === "1") {
            city = "La Paz";
          }
          if (_city === "2") {
            city = "Cochabamba";
          }
          if (_city === "3") {
            city = "Santa Cruz";
          }
          if (_city === "4") {
            city = "Tarija";
          }
          if (_city === "5") {
            city = "Sucre";
          }
          if (_city === "6") {
            city = "Potosí";
          }
          if (_city === "7") {
            city = "Oruro";
          }
          if (_city === "8") {
            city = "Cobija";
          }
          if (_city === "9") {
            city = "Beni";
          }

          let eventInfo = resp2.response;


          const _ordenes = resp2.response.ordenes ?? [];
          const _products = resp2.response.productos ?? [];
          // 1. Crear mapa de cantidades por SKU desde ordenes
          const skuAssignedMap = {};

          _ordenes.forEach(orden => {
            (orden.products ?? []).forEach(p => {
              const sku = String(p.sku);
              skuAssignedMap[sku] = (skuAssignedMap[sku] || 0) + Number(p.quantity || 0);
            });
          });
          // 2. Crear Set con los SKUs oficiales de productos
          const officialSkuSet = new Set(
            _products.map(p => String(p.sku))
          );

          // 3. Detectar SKUs extras (regalos adicionales)
          const extraProducts = [];

          Object.keys(skuAssignedMap).forEach(sku => {
            if (!officialSkuSet.has(sku)) {
              // buscar productid desde ordenes
              for (const orden of _ordenes) {
                const match = (orden.products ?? [])
                  .find(p => String(p.sku) === sku);
                if (match) {
                  extraProducts.push({
                    productid: match.productid,
                    sku: sku
                  });
                  break;
                }
              }
            }
          });

          // 4. Asignar quantity_assigned a productos normales
          _products.map(function (item) {

            item.quantity_assigned = skuAssignedMap[String(item.sku)] || 0;

            let pos = find(resp3.response, item.sku, "sku");
            let prod = resp3.response[pos];

            if (!prod) return; // protección extra

            let qtytObj = prod.storequantities
              ?.filter(key => Number(key.storeid) === Number(resp2.response.storeid));

            item.productname = prod.name;
            item.specific_name = prod.specific_name;
            item.images_path = prod.images_path;
            item.maxQuantity = qtytObj?.length ? qtytObj[0].quantity : item.quantity;
            item.productpath = formatPathName(prod.name) + "-" + prod.id;

            if (!item.commentsku) {
              item["commentsku"] = getDefValues().defCommentEventProdut;
            }
          });


          if (extraProducts.length > 0) {

            console.log("Productos extra detectados:", extraProducts);

            let resp3b = await callApiV2("customer", "getProductByIds", {
              productIds: extraProducts,
              accessKey: accessKey
            });

            // 1. Crear mapa de cantidades por SKU desde ordenes
            // 2. Asignar quantity_assigned a productos nuevos
            extraProducts.map(function (item) {
              item.quantity_assigned = skuAssignedMap[String(item.sku)] || 0;
              let pos = find(resp3b.response, item.sku, "sku");
              let prod = resp3b.response[pos];
              if (!prod) return; // protección extra

              let qtytObj = prod.storequantities
                ?.filter(key => Number(key.storeid) === Number(resp2.response.storeid));
              item.quantity = item.quantity_assigned
              item.productname = prod.name;
              item.specific_name = prod.specific_name;
              item.images_path = prod.images_path;
              item.maxQuantity = qtytObj?.length ? qtytObj[0].quantity : item.quantity;
              item.productpath = formatPathName(prod.name) + "-" + prod.id;
              item.tagid = 1
              item.eventid = eventid
              if (!item.commentsku) {
                item["commentsku"] = getDefValues().defCommentEventProdut;
              }
            });
            _products.push(...extraProducts);
          }


          const [year, month, day] = resp2.response.eventdate.split("-");
          const eventdate2 = `${day}/${month}/${year}`;

          this.setState({
            ...this.state,
            eventListInfo: { products: _products ?? [] },
            eventid: eventid,
            events: events,
            city: city,
            showEvents: showEvents,
            moreEvents: moreEvents,
            externalOrderFormData: externalOrderFormData,
            externalOrderFormConfig: externalOrderFormConfig,
            eventimage: resp2.response.imagepath,
            eventdate: resp2.response.eventdate,
            eventperson: resp2.response.datos_personales[0].firstname,
            eventdate2: eventdate2,
            eventmessage: resp2.response.message,
            eventname: resp2.response.eventname,
            eventInfo: eventInfo,
            userId: resp2.response.customerid,
            storeid: resp2.response.storeid,
            token: token,
            orders: _ordenes
          });
          let _pageData = await loadPageV2(
            respForm,
            this.managepagination,
            this.manageCart,
            this.changeHandler,
            this.manageButton,
            this.toggleModal,
            windowWidth
          );
          this.setState({ template: respForm });
          this.renderData(_pageData);

          layoutFile = "suggestedCategories";

          try {
            //let evenInfo = JSON.parse(resp2.EVENT.EVENT_FORMAT);
            layoutFile = "sugerencias_boda";//evenInfo.pathlayout;
          } catch (EX) {
            console.log("no layout founded");
          }

          const resp = await getS3PublicFile(
            process.env.REACT_APP_S3FILES + `/public/files/layouts/public/${layoutFile}.json`
          );

          let _pageData2 = await loadPageV2(
            resp,
            this.managepagination,
            this.manageCart,
            this.changeHandler,
            this.manageButton,
            this.toggleModal,
            windowWidth
          );
          this.setState({ template2: resp.template });
          this.renderData2(_pageData2);
        } else {
          //console.log("estado noton",noToken)
          if (!noToken) {
            this.setState({ isLoading: false, invalidEvent: true });
          } else {
            this.setState({
              isLoading: false,
              noEvents: true,
              messages: [
                getDefValues().notEventFoundsubTitleLabel1,
                getDefValues().notEventFoundsubTitleLabel2,
              ],
            });
          }
        }
      } else {
        this.setState({ modal1: true, isLoading: false });
      }

      document.addEventListener("scroll", this.handleResize);
    } catch (err) {
      console.log(">>>>>>>>>>", err);
    } finally {
      this.setState({ isLoading: false });
    }
    //window.addEventListener("resize", this.handleResize);
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleResize);
  }

  handleResize = async () => {
    var scrollCheck = window.scrollY;

    let maxSize = this.state.eventListInfo.products.length * 100 - 260;
    if (maxSize < 301) {
      maxSize = 301;
    }
    if (scrollCheck > 301) {
      scrollCheck = scrollCheck - 301;

      if (scrollCheck > maxSize) {
        scrollCheck = maxSize;
      }
    } else {
      scrollCheck = 0;
    }

    if (this.state.eventListInfo.products.length <= 3) {
      scrollCheck = 0;
    }

    //console.log("finl",scrollCheck)

    var resumeStyle = {
      position: "relative",
      rigth: "0px",
      top: scrollCheck,
      background: "#fff",
      zIndex: "999",
    };
    if (window.innerWidth <= 799) {
      resumeStyle = {};
    }
    this.setState({
      scrollCheck: scrollCheck,
      resumeStyle: resumeStyle,
      windowHeight: window.innerHeight,
    });
  };

  setEventById = async (eventid) => {
    let fields = [];
    for (let i in Object.keys(this.state)) {
      let field = Object.keys(this.state)[i];
      if (field.indexOf("2RENDEROBJ") >= 0) {
        //console.log("borrar", this.state[field] )
        let obj = this.state[field];
        obj["type"] = "NULL";
        fields.push(field);
        this.setState({ ...this.state, [field]: obj });
        //delete this.state[field]
      }
    }

    for (let f in fields) {
      this.setState({ ...this.state, [fields[f]]: null });
      //delete this.state[fields[f]]
    }

    this.setState({ ...this.state, showEvents: false, isLoading: true });
    //var finalFoldername = foldername;

    const respForm = await getS3PublicFile(
      process.env.REACT_APP_S3FILES +
      `/public/files/createEventForm.json`
    );

    var resp2 = await callApiV2("frontend", "getCustomerEventById", {
      id: eventid,
    });

    if (resp2.success) {
      let storesInfo = getSyncStoresInfo();
      if (storesInfo.selectedStoreId != resp2.response.storeid) {
        this.props.setStoreOff(resp2.response.storeid);
      }

      let resp3 = {}
      if (resp2.response.productos) {
        resp3 = await callApiV2("customer", "getProductByIds", { productIds: resp2.response.productos });
      }


      const form = await getS3PublicFile(
        process.env.REACT_APP_S3FILES +
        `/public/files/setExternalOrderForm.json`
      );

      let rendegObj = await getRenderObj(
        form[0],
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );

      let externalOrderFormData = rendegObj.curdata.data;
      let externalOrderFormConfig = rendegObj.curdata.config;
      let qty = 0;
      if (resp2.response.productos) {
        resp2.response.productos.map(function (item) {
          qty = qty + item.quantity;
        });
      }
      this.props.setEventMode(
        eventid,
        resp2.response.eventname,
        "addEventList",
        qty
      );

      let eventInfo = resp2.response;

      var _city = (resp2.response.city).toString;
      var city = "";
      if (_city === "1") {
        city = "La Paz";
      }
      if (_city === "2") {
        city = "Cochabamba";
      }
      if (_city === "3") {
        city = "Santa Cruz";
      }
      if (_city === "4") {
        city = "Tarija";
      }
      if (_city === "5") {
        city = "Sucre";
      }
      if (_city === "6") {
        city = "Potos\u00ED";
      }
      if (_city === "7") {
        city = "Oruro";
      }
      if (_city === "8") {
        city = "Cobija";
      }
      if (_city === "9") {
        city = "Beni";
      }
      const [year, month, day] = resp2.response.eventdate.split("-");
      const eventdate2 = `${day}/${month}/${year}`;

      var _products = resp2.response.productos ?? [];
      _products.map(function (item) {

        let pos = find(resp3.response, item.sku, "sku");
        let prod = resp3.response[pos]
        item.quantity_assigned = 0
        item.productname = prod.name
        item.specific_name = prod.specific_name
        item.images_path = prod.images_path
        item.maxQuantity = prod.storequantities.filter(key => Number(key.storeid) === Number(resp2.response.storeid));
        item.productpath = formatPathName(prod.name) + "-" + prod.id
        if (!item.commentsku) {
          item["commentsku"] = getDefValues().defCommentEventProdut;
        }
      });
      this.setState({
        ...this.state,
        eventListInfo: { products: _products ?? [] },
        eventid: eventid,
        city: city,
        externalOrderFormData: externalOrderFormData,
        externalOrderFormConfig: externalOrderFormConfig,
        eventimage: resp2.response.imagepath,
        eventdate: resp2.response.eventdate,
        eventperson: resp2.response.datos_personales[0].firstname,
        eventdate2: eventdate2,
        eventmessage: resp2.response.message,
        eventname: resp2.response.eventname,
        eventInfo: eventInfo,
        userId: resp2.response.customerid,
        storeid: resp2.response.storeid,
      });
      let _pageData = await loadPageV2(
        respForm,
        this.managepagination,
        this.manageCart,
        this.changeHandler,
        this.manageButton,
        this.toggleModal,
        windowWidth
      );
      this.setState({ template: respForm });
      this.renderData(_pageData);

      let layoutFile = "suggestedCategories"

      try {
        //let evenInfo = JSON.parse(resp2.EVENT.EVENT_FORMAT);
        layoutFile = "sugerencias_boda";//evenInfo.pathlayout;
      } catch (EX) {
        console.log("no layout founded");
      }

      const resp = await getS3PublicFile(
        process.env.REACT_APP_S3FILES + `/public/files/layouts/public/${layoutFile}.json`
      );

      let _pageData2 = await loadPageV2(
        resp,
        this.managepagination,
        this.manageCart,
        this.changeHandler,
        this.manageButton,
        this.toggleModal,
        windowWidth
      );
      this.setState({
        template2: resp.template,
        isLoading: false,
        formstep: 2,
      });
      this.renderData2(_pageData2);
    }
  };
  refreshEventProducts = async (event) => {
    var resp2 = await callApiV2("frontend", "getCustomerEventById", {
      id: this.state.eventid,
    });

    let resp3 = {}
    if (resp2.response.productos) {
      resp3 = await callApiV2("customer", "getProductByIds", { productIds: resp2.response.productos });
      console.log("Resp3", resp3)
    }

    var _products = resp2.response.productos ?? [];
    _products.map(function (item) {

      let pos = find(resp3.response, item.sku, "sku");
      let prod = resp3.response[pos]
      item.quantity_assigned = 0
      item.productname = prod.name
      item.specific_name = prod.specific_name
      item.images_path = prod.images_path
      item.maxQuantity = prod.storequantities.filter(key => Number(key.storeid) === Number(resp2.response.storeid));
      item.productpath = formatPathName(prod.name) + "-" + prod.id
      if (!item.commentsku) {
        item["commentsku"] = getDefValues().defCommentEventProdut;
      }
    });

    if (resp2.success) {
      this.setState({
        ...this.state,
        eventListInfo: { products: _products ?? [] },
      });
    }
  };

  renderData = (_pageData) => {
    try {
      //check_!!! this.setState({city: _pageData[2].data.city.values[0].text})
      var personalData = this.state.eventInfo.datos_personales;

      var fieldsPD = Object.keys(personalData[0]);
      for (let r in _pageData) {
        let fieldsF = Object.keys(_pageData[r].data);
        // console.log("fieldsF", fieldsF, ":::", fieldsF.toString(), fieldsPD.toString())


        const areEqual =
          fieldsF.length === fieldsPD.length &&
          fieldsF.sort().every((val, index) => val === fieldsPD.sort()[index]);

        if (areEqual) {
          if (personalData.length > 0) {
            var arrData = [];
            var item = 1;
            for (let d in personalData) {
              let formName =
                (_pageData[r].config.formsubtitle
                  ? _pageData[r].config.formsubtitle
                  : "ITEM") + item;
              let newDataNames = [];
              let curFields = _pageData[r].data;
              let newData = [];

              for (let i in Object.keys(curFields)) {
                let field = Object.keys(curFields)[i];
                newDataNames.push(field);
                let newValues = [];
                //let initVal;
                if (curFields[field].values) {
                  for (let j in curFields[field].values) {
                    if (j === 0) {
                      //initVal = curFields[field].values[j].value;
                    }
                    let row = {
                      text: "1",
                      value: "value",
                    };
                    newValues.push(row);
                  }
                }
                let objField = {};
                if (curFields[field].values) {
                  objField["values"] = newValues;
                }
                for (let f in Object.keys(curFields[field])) {
                  let fieldName = Object.keys(curFields[field])[f];
                  if (fieldName === "value") {
                    if (Array.isArray(curFields[field].values)) {
                      if (curFields[field].values.length > 0) {
                        objField["value"] = 1;
                      } else {
                        objField["value"] = "";
                      }
                    } else {
                      objField["value"] = "";
                    }
                  } else {
                    objField[fieldName] = curFields[field][fieldName];
                  }
                }
                newData.push(objField);
              }
              let finalData = {};
              for (let i in newDataNames) {
                finalData[newDataNames[i]] = newData[i];
              }
              //let loadData =
              //console.log("f", finalData, personalData[d])
              mergeFormData(finalData, personalData[d]);
              arrData.push({
                formName: formName,
                formLabel: formName,
                formConfig: _pageData[r].config,
                formData: finalData,
                formOptionID: item - 1,
              });
              item++;
            }
            _pageData[r]["originaldata"] = _pageData[r].data;
            _pageData[r]["data"] = arrData;
            _pageData[r]["activeForm"] = 0;
          } else {
            //let loadData =
            mergeFormData(_pageData[r].data, personalData[0]);
          }
        } else {
          //let loadData =
          mergeFormData(_pageData[r].data, this.state.eventInfo);
        }
        if (_pageData[r].data["directions"]) {
          let finalValue = _pageData[r].data["directions"].value;
          let finalLabel = "";
          Object.keys(finalValue).map(function (field) {
            finalLabel = finalLabel + finalValue[field] + ", ";
          });
          let values = [{ text: finalLabel, value: finalValue }];
          _pageData[r].data["directions"].values = values;
          _pageData[r].data["directions"].buttonlabel =
            getDefValues().setAddressLabel;
        }
        this.setState({
          ["RENDEROBJ" + _pageData[r].ObjectName]: _pageData[r],
        });
      }
      //console.log("-final-", this.state)
    } catch (err) {
      console.log(">>>>>>>>>>>", err);
    }
  };

  renderData2 = (_pageData) => {
    try {
      //console.log("-_pageData-", _pageData)
      for (let r in _pageData) {
        this.setState({
          ["2RENDEROBJ" + _pageData[r].ObjectName]: _pageData[r],
        });
      }
      //console.log("-final-", this.state)
    } catch (err) {
      console.log(">>>>>>>>>>>", err);
    }
  };

  editForm = (event) => {
    this.setState({ lockform: false, isValid: false });
  };

  toggleModal = (event) => {
    let object = findObjName(event);
    //console.log(object, this.state["RENDEROBJ"+object])
    let newTemplate = toggleModalManager(this.state["RENDEROBJ" + object]);
    this.setState({ ["RENDEROBJ" + object]: newTemplate });
  };

  changeHandler = async (event) => {
    let object = findObjName(event);
    let fieldName = object.split("__");
    if (fieldName[1] === "ADD") {
      this.setState({
        activeMapForm: fieldName[0],
        activeMapValue: fieldName[2],
      });
      this.showpopupdirections();
    } else {
      if (event?.target?.name.indexOf("datos_evento__imagepath") >= 0) {
        //console.log("update image")
        this.setState({ eventimage: event.target.value });
      }

      if (event?.target?.name.indexOf("city") >= 0) {
        var city = "";
        if (event.target.value == "1") {
          city = "La Paz";
        }
        if (event.target.value == "2") {
          city = "Cochabamba";
        }
        if (event.target.value == "3") {
          city = "Santa Cruz";
        }
        if (event.target.value == "4") {
          city = "Tarija";
        }
        if (event.target.value == "5") {
          city = "Sucre";
        }
        if (event.target.value == "6") {
          city = "Potos\u00ED";
        }
        if (event.target.value == "7") {
          city = "Oruro";
        }
        if (event.target.value == "8") {
          city = "Cobija";
        }
        if (event.target.value == "9") {
          city = "Beni";
        }

        this.setState({ city: city });
      }
      let newTemplate = changeHandlerManager(
        this.state["RENDEROBJ" + fieldName[0]],
        fieldName[1],
        event.target.value
      );
      this.setState({ ["RENDEROBJ" + fieldName[0]]: newTemplate });
    }
  };

  handleChangeSKU = (event) => {
    this.setState({ skuToAdd: event.target.value });
  };

  delSku = async (sku) => {
    let newSkus = this.state.skus;
    let pos = find(this.state.skus, sku, "sku");
    newSkus.splice(pos, 1);
    this.setState({ skus: newSkus });
  };

  addSKUToOrder = async (event) => {
    console.log("addSKUToOrder", event)
    let newSkus = this.state.skus;
    var pos1 = find(
      this.state.eventListInfo.products,
      this.state.skuToAdd,
      "sku"
    );
    console.log("p", this.state.eventListInfo.products, this.state.skuToAdd)
    let pos2 = find(newSkus, this.state.skuToAdd, "sku");

    console.log(this.state.eventListInfo.products);

    var isNew = false;
    var isValid = true;
    if (pos1 < 0) {
      console.log("l1", this.state.eventListInfo.products.length)

      //console.log("pos1")
      this.setState({ isLoading2: true });
      var formData = {
        sku: this.state.skuToAdd,
        productid: 0,
        eventid: String(this.state.eventid),
        quantity: 1,
      };
      var resp = await callApiV2("frontend", "setProductEvent", formData);
      console.log("resp", resp);
      if (resp.success) {


        isNew = true;
        showMessage(toast, getDefValues().successfullyAddedToEventListLabel);
        await this.refreshEventProducts();
        console.log("l2", this.state.eventListInfo.products.length)
        console.log("eventListInfo", this.state.eventListInfo)
        pos1 = find(
          this.state.eventListInfo.products,
          this.state.skuToAdd,
          "sku"
        );
      } else {
        isValid = false;
        showError(toast, getDefValues().errorAddedToNewSKULabel);
      }
      this.setState({ isLoading2: false });
    }

    if (isValid) {
      console.log(this.state.eventListInfo.products)
      let skuData = this.state.eventListInfo.products[pos1];

      let imagePath = skuData.images_path + "" + skuData.sku + "_1" + getImageExtension()
      if (skuData.sku.includes(",")) {
        imagePath = skuData.images_path + "_1" + getImageExtension()
      }

      if (pos2 < 0) {
        //console.log("1")

        let maxQty = skuData.quantity - skuData.quantity_assigned;
        if (maxQty > 0) {
          let newSku = {
            productid: skuData.productid,
            sku: skuData.sku,
            image: imagePath,
            quantity: 1,
            maxQuantity: skuData.maxQuantity,
            quantity_assigned: skuData.quantity_assigned,
          };
          newSkus.push(newSku);
        } else {
          if (!isNew) {
            showWarning(toast, getDefValues().skuExceededMessage2);
          }
          let newSku = {
            productid: skuData.productid,
            sku: skuData.sku,
            image: imagePath,
            quantity: 1,
            maxQuantity: skuData.maxQuantity,
            quantity_assigned: skuData.quantity_assigned,
          };
          newSkus.push(newSku);
        }
      } else {
        console.log("2", newSkus[pos2]["quantity"], skuData.maxQuantity);

        if (newSkus[pos2]["quantity"] < skuData.maxQuantity) {
          let currSkuData = newSkus[pos2];
          let currQty = currSkuData.quantity + 1;
          let maxQty = skuData.quantity - skuData.quantity_assigned;

          if (currQty <= maxQty) {
            newSkus[pos2]["quantity"] = currQty;
          } else {
            newSkus[pos2]["quantity"] = currQty;
            if (!isNew) {
              showWarning(toast, getDefValues().skuExceededMessage2);
            }
          }
        } else {
          showError(toast, getDefValues().skuExceededMessage);
        }
      }
      this.setState({ skus: newSkus });
    }
  };

  changeHandlerD = async (event) => {
    //console.log("eventD", event)
    var formData = changeHandler(event, this.state.externalOrderFormData);
    this.setState({ externalOrderFormData: formData });

    if (event.key === "Enter") {
      this.registerOrder(event);
    }
  };

  registerOrder = async (event) => {
    this.setState({ isLoading2: true });
    try {

      const skus = this.state.skus;
      console.log("this.state.eventListInfo", this.state.eventListInfo)
      console.log("this.state.skus", this.state.skus)
      const products = this.state.eventListInfo.products

        .filter(p => skus.some(s => s.sku === p.sku))      // dejar solo los que existen en skus
        .map(p => {
          const skuData = skus.find(s => s.sku === p.sku); // buscar info del sku
          return {
            ...p,
            quantity: skuData.quantity,
            productsku: p.sku,
            price: 0,
            subtotal: 0,
            productpath: p.productname + "-" + p.productId,
            image: skuData.image,
            productname: p.specific_name
          };
        });

      console.log("products", products)
      console.log("this.state.eventInfo", this.state)

      var formData = {
        storeid: this.state.eventInfo.storeid,
        paymentMethod: "EVENT",
        paymenttypeid: 0,
        "statusid": 1,
        "shippingtypeid": 6,
        "shippingLabel": "Eventos regalables",
        "shippingcost": 0,
        "subtotal": 0,
        "discountShipping": 0,
        "paymnettype": "DIRECT",
        "customerid": 0,
        "shippingType": "EVENT",
        "city": this.state.eventInfo.city,
        addressinfo: "",
        "invoiceid": 0,
        "discount": 0,
        coupons: [],
        "validcouponcode": [],
        "email": "noemail@mail.com",
        "code": "0",
        "lastname2": "",
        "phonecode": "+591",
        "phone": "0",
        "invoicelabel": "",
        "tipodoc": "5",
        "complemento": "",
        "invoicename": "vasquez",
        products: products,
        eventid: this.state.eventInfo.eventcode,
        eventname: this.state.eventname

      };
      var resp = await validateForm(this.state.externalOrderFormData, toast);

      if (resp.isValid) {

        let _formData = this.state.externalOrderFormData;
        _formData = parseFormData(_formData);

        console.log("_formData", _formData)
        Object.assign(formData, _formData);

        if (_formData.dedicationcheck === "CLIENTE") {
          formData.paymenttypeid = 4
          formData.paymentMethod = "EVENTO-CLIENTE"
        } else if (_formData.dedicationcheck === "YES") {
          formData.paymenttypeid = 5
          formData.paymentMethod = "EVENTO-SI"
        } else if (_formData.dedicationcheck === "NO") {
          formData.paymenttypeid = 6
          formData.paymentMethod = "EVENTO-NO"
        }
        formData.firstname = _formData.firstname
        formData.lastname = _formData.lastname
        formData.numero_factura = _formData.numero_factura
        formData.trx = _formData.trx
        formData.storename = _formData.storename
        formData.total = 0
        formData["type"] = "external"
        formData.dedicationInfo = {
          name: formData.firstname + " " + formData.lastname,
          message: formData.dedicationmessage
        }
        console.log(formData)
        let resp = await callApiV2("frontend", "setOrders", formData);
        if (resp.success) {
          showMessage(toast, getDefValues().successfullyOrderRegisteredLabel);
          await this.refreshEventProducts();
          this.setState({
            ...this.state,
            modal3: false,
            skuToAdd: "",
            externalOrder: true,
            externalOrderId: resp.id,
            skus: [],
          });
        } else {
          showError(toast, getDefValues().errorOrderRegisteredLabel);
        }
      }
    } catch (Excep) {
      this.setState({ isLoading2: false });
      console.log(">>>>>>>", Excep);
    } finally {
      this.setState({ isLoading2: false });
    }
  };

  changeForm = async (event) => {
    this.setState({ isLoading: true });
    let object = findObjName(event);
    let fieldName = object.split("__");
    let newTemplate = this.state["RENDEROBJ" + fieldName[0]];
    newTemplate["activeForm"] = event.target.value;
    this.setState({ ["RENDEROBJ" + fieldName[0]]: newTemplate });
    setTimeout(
      function () {
        this.setState({ ["RENDEROBJ" + fieldName[0]]: newTemplate });
        this.setState({ isLoading: false });
      }.bind(this),
      250
    );
  };

  manageCart = async (event) => {
    //let object = findObjName(event);
    let container;
    if (event.target.name) {
      container = event.target.id;
    } else {
      container = event.target.parentNode.id;
    }

    try {
      this.setState({ isLoading2: true });
      var resp = await manageCart(
        event,
        this.state["RENDEROBJ" + container].data,
        this.manageCart,
        toast
      );
      if (resp.success) {
        if (!resp.redirect) {
          this.setState({
            ...this.state,
            isLoading: false,
            //cardData: resp._cardData
          });
          if (resp.dataCart) {
            this.props.updateCart(resp.dataCart);
          }
        } else {
          this.setState({
            ...this.state,
            isLoading: false,
            selectedProductID: resp.selectedProductID,
            selectedPath: resp.selectedPath,
            selectedCategory: resp.selectedCategory,
            redirectProductDetails: true,
          });
        }
      } else {
        this.setState({ ...this.state, isLoading: false });
        console.log(">>>>>>>", resp.message);
      }

      this.setState({ isLoading2: false });
    } catch (Excep) {
      this.setState({ isLoading2: false });
      console.log(">>>>>>>", Excep);
    }
  };

  showpopupdirections = async (event) => {
    this.setState({ isLoading2: true });

    const form = await getS3PublicFile(
      process.env.REACT_APP_S3FILES +
      `/public/files/addressForm.json`
    );


    let rendegObj = await getRenderObj(
      form[0],
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );
    rendegObj.curdata.config["btncolor"] = "secondary";
    delete rendegObj.curdata.data["alias"];

    rendegObj.curdata.data["city"].values = [
      { value: this.state.city, text: this.state.city },
    ];
    rendegObj.curdata.data["city"].value = this.state.city;

    this.setState({
      addressFormData: rendegObj.curdata.data,
      addressFormConfig: rendegObj.curdata.config,
      shippingFormId: form[0].componentid,
    });
    this.setState({
      modal4: true,
      showMap: false,
      showFormAdd: true,
      isLoading2: false,
    });
  };
  changeHandlerA = async (event) => {
    //console.log("eventA", event)
    var formData = changeHandler(event, this.state.addressFormData);
    this.setState({ addressFormData: formData });
    if (event.key === "Enter") {
      this.saveTempLocation(event);
    }
  };
  closeMap = (event) => {
    this.setState({ ...this.state, modal4: false, showMap: false });
    this.props.toggleListener();
  };

  hideMap = (event) => {
    this.setState({ showMap: false, showFormAdd: true });
    this.props.toggleListener();
  };

  saveTempLocation = async (event) => {
    var resp = await validateForm(this.state.addressFormData, toast);
    if (resp.isValid) {
      this.props.toggleListener();
      this.setState({
        showMap: true,
        showFormAdd: false,
        address: this.state.addressFormData.address.value,
        city: this.state.addressFormData.city.value,
      });
    }
  };

  setMyLocation = async (event) => {
    this.setState({ showMap: false });
    await navigator.geolocation.getCurrentPosition(
      async function (position) {
        let latitude = position.coords.latitude;
        let longitude = position.coords.longitude;
        this.setState({
          latitude: latitude,
          longitude: longitude,
          showMap: true,
        });
      }.bind(this)
    );
  };

  setLocation = async (event, add) => {
    if (event.lat) {
      this.setState({
        clatitude: event.lat,
        clongitude: event.lng,
        caddress: add,
      });
    }
  };

  confirmLocation = async (event) => {
    this.setState({ isLoading2: true });
    try {
      let _formData = this.state.addressFormData;
      _formData = parseFormData(_formData);
      var finalValue = {};
      var finalLabel = "";
      Object.keys(_formData).map(function (field) {
        finalLabel = finalLabel + _formData[field] + ", ";
        finalValue[field] = _formData[field];
      });
      finalLabel = finalLabel + " LAT:" + event.lat + ", LNG:" + event.lng;

      let title = (_formData["alias"] || 'Evento').toUpperCase();
      var addLabel = _formData["address"];

      finalValue["latitude"] = event.lat;
      finalValue["longitude"] = event.lng;
      finalValue["zonecode"] = event.zonecode;
      var formData = this.state["RENDEROBJ" + this.state.activeMapForm]["data"];
      //formData[this.state.activeMapValue].values = [{value: finalValue, text:"",aditionalText :finalLabel}]
      formData[this.state.activeMapValue].values = [
        {
          value: finalValue,
          text: title /*---*/,
          aditionalText: addLabel /*finalLabel*/,
        },
      ];
      formData[this.state.activeMapValue].value =
        formData[this.state.activeMapValue].values[0].value;

      this.setState({
        modal4: false,
        showMap: false,
        showFormAdd: true,
        haveDirection: true,
      });
    } catch (Excep) {
      console.log(">>>>>>>", Excep);
    } finally {
      this.setState({ isLoading2: false });
    }
  };

  manageButton = async (event) => {
    try {
      this.setState({ isLoading2: true });
      let object = findObjName(event);
      var fieldName = object.split("__");
      //let storesInfo = getSyncStoresInfo()

      const { userId, RENDEROBJdatos_personales, RENDEROBJdatos_entrega, RENDEROBJdatos_evento } = this.state;
      // Base del formulario
      const formData = {
        userId,
        storeid: Number(this.state.storeid),
        eventid: this.state.eventid,
      };

      // Procesar datos personales
      const personalDataArray = Array.isArray(RENDEROBJdatos_personales?.data)
        ? RENDEROBJdatos_personales.data.map(async (item) => {


          let validation = await validateForm(item.formData, toast);

          console.log("validation", validation)
          const parsed = parseFormData(item.formData);
          console.log("parsed (array item):", parsed);
          return {
            ...parsed,
            numdoc: String(formData.numdoc || parsed.numdoc || ""), // aseguramos que sea string
          };
        })
        : (() => {
          const parsed = parseFormData(RENDEROBJdatos_personales?.data);
          console.log("parsed (single object):", parsed);
          return [
            {
              ...parsed,
              numdoc: String(formData.numdoc || parsed.numdoc || ""), // unifica la lógica
            },
          ];
        })();



      let validation = await validateForm(RENDEROBJdatos_entrega.data, toast);

      console.log("validation", validation)

      // Procesar datos de entrega y evento
      const deliveryData = parseFormData(RENDEROBJdatos_entrega?.data || {});
      const eventData = parseFormData(RENDEROBJdatos_evento?.data || {});


      const localDate = new Date(eventData.eventdate);

      const fEventDate = localDate
        .toLocaleDateString("en-CA", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });

      // Combinar todo en un solo objeto
      const fullData = {
        ...formData,
        ...deliveryData,
        ...eventData,
        datos_personales: personalDataArray,
        storeid: Number(formData.storeid),
        eventtypeid: Number(eventData.eventtypeid),
        eventdate: fEventDate
      };
      if (fullData.hasOwnProperty("")) {
        delete fullData[""];
      }
      delete fullData.link1
      console.log("fullData:", fullData);


      var resp = await callApiV2("customer", "updEvent", fullData);

      if (resp.success) {
        //console.log(formData)

        let eventname = formatPathName(fullData.eventname);
        let eventToken = eventname.replace(/[^a-zA-Z0-9]/g, "-");
        eventToken = eventToken.replaceAll("---", "-");
        eventToken = eventToken.replaceAll("--", "-");
        eventToken += "-" + this.state.eventid;

        var shareUrl =
          process.env.REACT_APP_URL_FRONT_CONFIG +
          "/customer/event/event-details/" +
          eventToken;

        var eventdate2 = this.state.eventdate2;

        if (typeof fullData.eventdate != "string") {
          console.log("fecha", fullData)

          const today = new Date(formData.eventdate);
          const yyyy = today.getFullYear();
          let mm = today.getMonth() + 1; // Months start at 0!
          let dd = today.getDate();

          if (dd < 10) dd = "0" + dd;
          if (mm < 10) mm = "0" + mm;

          eventdate2 = dd + "/" + mm + "/" + yyyy;
        }

        console.log(this.state.eventdate2, "new:", eventdate2)
        console.log("formData", fullData)
        this.setState({
          lockform: true,
          eventimage: fullData.imagepath,
          eventdate2: eventdate2,
          eventname: fullData.eventname,
          eventperson: fullData.datos_personales[0].firstname,
          eventmessage: fullData.message,
          shareUrl: shareUrl,
          formstep: 2,
        });
      }

      this.setState({ isLoading2: false });
    } catch (err) {
      console.log(">>>>>>>>>>>", err);
      this.setState({ isLoading2: false });
    }
  };

  managepagination = (event) => {
    this.setState({ isLoading: true });

    //let object = findObjName(event);
    let _container;
    if (event.target.name) {
      _container = event.target.id.split("__");
    } else {
      _container = event.target.parentNode.id.split("__");
    }
    let container = _container[0];
    setTimeout(
      function () {
        var newpagesettings = managepagination(
          this.state["RENDEROBJ" + container].config.pagesettings,
          event
        );
        var newcardConfig = {
          pagewidth: "col-md-12 col-lg-12 col-xl-12",
          colsize: "col-6",
          colsizelg: "col-lg-2_5",
          colsizemd: "col-md-4",
          colsizesm: "col-sm-6",
          pagination: true,
          managepagination: this.managepagination,
          pagesettings: newpagesettings,
          /*overtop            :"YES"*/
        };
        this.setState({ cardConfig: newcardConfig, isLoading: false });
      }.bind(this),
      1000
    );
  };
  managesort = (event) => {
    this.setState({ isLoading: true });
    //console.log(event.target)
    //let object = findObjName(event);
    let container;
    if (event.target.name) {
      container = event.target.id;
    } else {
      container = event.target.parentNode.id;
    }
    setTimeout(
      function () {
        var newcardData = managesort(
          this.state["RENDEROBJ" + container],
          event
        );
        this.setState({ cardData: newcardData, isLoading: false });
      }.bind(this),
      1000
    );
  };

  toggle = (nr) => () => {
    let modalNumber = "modal" + nr;

    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });

    if (nr === 4 && !this.state.modalNumber) {
      this.setState({ showMap: false });
    }
  };

  toggleDelete = () => {
    this.setState({
      showConfirm: !this.state.showConfirm,
    });
  };

  confimDelete = async (event) => {
    this.setState({ isLoading: true });
    var data = await updateEventList(
      this.state.eventListInfo,
      this.state.listProductId,
      this.state.listAction,
      toast,
      this.state.listValue
    );
    if (data) {
      this.setState({ ...this.state, isLoading: false, eventListInfo: data });
      let qty = 0;
      data.products.map(function (item) {
        qty = qty + item.quantity;
      });
      this.props.setQtyEvent(qty);
    } else {
      this.setState({ ...this.state, isLoading: false, showConfirm: false });
    }
  };
  updateEventList2 = async (event) => {
    console.log("updateEventList2", event)
    let object = findObjName(event);
    var values = object.split("__");
    const skus = this.state.skus;
    let pos = find(skus, values[1], "sku");
    if (values[0] === "increase") {
      console.log("add", skus[pos]);
      if (skus[pos]["quantity"] < skus[pos]["maxQuantity"]) {
        skus[pos]["quantity"] = skus[pos]["quantity"] + 1;
      } else {
        showError(toast, getDefValues().skuExceededMessage);
      }
    } else {
      if (skus[pos]["quantity"] > 1) {
        skus[pos]["quantity"] = skus[pos]["quantity"] - 1;
      }
    }
    this.setState({ ...this.state, skus: skus });
    console.log("entr", event.target, values, this.state.skus);
  };

  updateEventList = async (event) => {
    //console.log("updateEventList", event)
    this.setState({ isLoading: true });

    try {
      let object = findObjName(event);
      var values = object.split("__");
      var action = values[0];
      var productId = values[1];

      //console.log("products", this.state.eventListInfo)
      //var eventListInfo = this.state.eventListInfo
      if (action === "del") {
        this.setState({
          ...this.state,
          isLoading: false,
          listAction: action,
          listProductId: productId,
          listValue: event.target.value,
          showConfirm: true,
        });
      } else {
        var data = await updateEventList(
          this.state.eventListInfo,
          productId,
          action,
          toast,
          event.target.value
        );
        if (data) {
          this.setState({
            ...this.state,
            isLoading: false,
            eventListInfo: data,
          });
          let qty = 0;
          data.products.map(function (item) {
            qty = qty + item.quantity;
          });
          this.props.setQtyEvent(qty);
        } else {
          this.setState({ ...this.state, isLoading: false });
        }
      }
    } catch (Excep) {
      this.setState({ isLoading: false });
      console.log(">>>>>>>", Excep);
    }
  };

  getTokenEventlist = async () => {
    try {
      console.log("getTokenEventlist", this.state)
      if (this.state.shareUrl !== "") {
        this.setState({ ...this.state, modal2: true });
      } else {
        this.setState({ ...this.state, isLoading2: true, modal2: true });


        let eventid = this.state.eventid
        console.log("T", eventid)
        let eventname = formatPathName(this.state.eventname);
        let eventToken = eventname.replace(/[^a-zA-Z0-9]/g, "-");
        eventToken = eventToken.replaceAll("---", "-");
        eventToken = eventToken.replaceAll("--", "-");
        eventToken += "-" + eventid;
        let resp
        var url =
          process.env.REACT_APP_URL_FRONT_CONFIG +
          "/customer/event/event-details/" +
          eventToken;
        //url = "http://cidev-front.casaideas.com.bo"+"/customer/event/event-details/"+resp.token
        try {
          const bitly = new BitlyClient(process.env.REACT_APP_BITLYKEY, {});
          resp = await bitly.shorten(url);
          url = resp.url;
        } catch (Exc) {
          //console.log("Exc bitly >>>",Exc )
        }
        var message = (
          <span className="text-secondary">
            {" "}
            {getDefValues().myWishListTokenMessage}{" "}
          </span>
        );
        this.setState({ ...this.state, shareUrl: url, message });

      }
    } catch (Excep) {
      console.log(">>>>>>>", Excep);
    } finally {
      this.setState({ isLoading2: false });
    }
  };
  toggleMoreUrl = () => {
    this.setState({
      showMoreUrl: !this.state.showMoreUrl,
    });
  };

  copyTextToClipboard = async () => {
    await navigator.clipboard.writeText(this.state.shareUrl);
    this.setState({
      isCopied: true,
    });
  };

  shareEvent = (event) => {
    try {
      var socialNetwork = findObjName(event);

      //	console.log(socialNetwork)

      var url = this.state.shareUrl;
      var title = this.state.eventname;

      shareEvent(
        socialNetwork,
        url,
        title,
        500,
        350,
        getDefValues().shareEventMessageLabel
      );
    } catch (Excep) {
      console.log(">>>>>>>", Excep);
    }
  };

  callBackSNError = (res) => {
    console.log("Login failed: res:", res);
  };

  changeHandlerL = async (event) => {
    //let resp = await validateForm(this.state.formData, toast,event);
    //this.setState({formData:resp.formData});

    //console.log("eventL", event)

    var formData = changeHandler(event, this.state.formData);
    this.setState({ formData: formData });

    if (event.key === "Enter") {
      this.login(event);
    }
  };

  login = async (event) => {
    try {
      this.setState({ isLoading: true });
      var resp = await login(this.state.formData, this.state.rememberme, toast);
      if (resp.success) {
        this.setState({ isLoading: false, modal1: false, reloadPage: true });
        this.props.setLoginInfo(event);
        window.location.reload();
      } else {
        this.setState({ isLoading: false });
      }
    } catch (Excep) {
      this.setState({ isLoading: false });
      console.log(">>>>>>>", Excep);
    }
  };

  toggleLogin = (nr) => () => {
    let show = "show" + nr;
    this.setState({
      [show]: !this.state[show],
    });
  };

  changePanel = (nr) => () => {
    this.setState({
      formstep: nr,
    });
  };

  render() {
    const MapLoader = withScriptjs(Map);

    if (this.state.showEvents) {
      return (
        <div style={{ height: 420 }}>
          <MDBModal
            isOpen={this.state.showEvents}
            fade
            centered
            className="fullheigth-modal show-events-modal"
          >
            <MDBModalBody>
              <p className="flex items-left mt-3">
                <span className="h4-responsive">
                  {" "}
                  {getDefValues().selectEventLabel}{" "}
                </span>
              </p>

              <div className="row mt-50 mb-10 body-content">
                <div className="col-12">
                  {this.state.events.map((item) => (
                    <div className="row flex middle ">
                      <div className="col-3 col-sm-3 col-md-3 col-lg-2  ">
                        <img
                          onClick={() => this.setEventById(item.eventcode)}
                          alt={item.eventname}
                          src={getImagePath(item.imagepath)}
                          className="card-img-top"
                        />
                      </div>
                      <div className="col-9 col-sm-9 col-md-9 col-lg-10  pl-1">
                        <span onClick={() => this.setEventById(item.eventcode)}>
                          {item.EVENTINFO.eventname}{" "}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </MDBModalBody>
          </MDBModal>
        </div>
      );
    } else {
      /*<NotFounded messages={this.state.messages}/>*/
      if (this.state.noEvents) {
        return <Redirect to={{ pathname: "/customer/event/create-event" }} />;
      } else {
        return this.props.showSearcher ? (
          ""
        ) : (
          <>
            <PageLoading isLoading={this.state.isLoading} />
            <PageLoading isLoading={this.state.isLoading2} />

            <Modal
              content={
                <>
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 text-center mb-30 mt-30 ">
                      <h4> {getDefValues().deleteProductEventMessage} </h4>
                    </div>
                  </div>
                </>
              }
              staticBackdrop={false}
              toogleCloseButton={true}
              formAction={this.confimDelete}
              btncolor={"secondary"}
              formButtonLabel={getDefValues().yeslabel}
              secondaryFormButtonLabel={getDefValues().nolabel}
              toggleModal={this.toggleDelete}
              modal={this.state.showConfirm}
              btncolorbtncolor="secondary"
            />

            <Modal
              height={150}
              minHeight={150}
              lg={false}
              overflowY={"hidden"}
              top={false}
              content={
                <div
                  style={{ height: 140 }}
                  className="row flex middle text-center"
                >
                  <div className="col-12">
                    <h3> Orden Generada Nro: {this.state.externalOrderId}</h3>
                  </div>
                </div>
              }
              staticBackdrop={true}
              toogleCloseButton={true}
              hideCloseButton={true}
              toggleModal={this.showExternalOrder}
              modal={this.state.externalOrder}
            />

            <MDBModal
              isOpen={this.state.modal4}
              toggle={this.toggle(4)}
              fade
              centered
              className="fullheigth-modal"
            >
              <MDBModalHeader>
                <span className="h6-responsive">
                  {" "}
                  {getDefValues().chooseMapPoint}{" "}
                </span>
              </MDBModalHeader>
              <MDBModalBody className="popup-map">
                {this.state.showFormAdd ? (
                  <Form
                    formData={this.state.addressFormData}
                    changeHandler={this.changeHandlerA}
                    formConfig={this.state.addressFormConfig}
                  />
                ) : (
                  ""
                )}

                {this.state.showMap ? (
                  <MapLoader
                    coords={{
                      lat: this.state.latitude,
                      lng: this.state.longitude,
                    }}
                    height="380px"
                    setMyLocation={this.setMyLocation}
                    setLocation={this.setLocation}
                    address={this.state.address}
                    city={this.state.city}
                    googleMapURL={
                      "https://maps.googleapis.com/maps/api/js?key=" +
                      GoogleMapsAPI +
                      "&libraries=places"
                    }
                    backLocation={this.hideMap}
                    cancelLocation={this.closeMap}
                    btncolor="secondary"
                    confirmLocation={this.confirmLocation}
                    loadingElement={<div style={{ height: `380px` }}></div>}
                  />
                ) : (
                  ""
                )}
              </MDBModalBody>

              <div className="card">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 flex items-center">
                    {this.state.showFormAdd ? (
                      <>
                        <button
                          className={
                            "btn btn-md btn-secondary shipping-form-btn mr-1"
                          }
                          type="button"
                          onClick={this.saveTempLocation}
                        >
                          {getDefValues().selectLocationLabel}
                        </button>
                        <button
                          className="btn btn-md btn-outline-secondary shipping-form-btn"
                          type="button"
                          onClick={this.closeMap}
                        >
                          {getDefValues().cancelLabel}
                        </button>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </MDBModal>

            <MDBModal
              isOpen={this.state.modal1}
              toggle={this.toggle(1)}
              fade
              centered
              className="fullheigth-modal"
            >
              <MDBModalBody>
                <p className="flex items-left mt-3">
                  <img src={ico_login} alt="login" />
                  <span className="h3-responsive">
                    {" "}
                    {getDefValues().loginLabel}{" "}
                  </span>
                </p>

                {this.state.needLogin ? (
                  <MDBAlert color="warning" className="">
                    <p sytle={{ marginBottom: 5 }}>
                      <span className="h5-responsive">
                        {" "}
                        {getDefValues().needLoginMessage}{" "}
                      </span>
                    </p>
                  </MDBAlert>
                ) : (
                  ""
                )}

                <div className="text-muted flex items-center mt-3">
                  <span>{getDefValues().loginWithSocialNetwork}</span>
                </div>

                <p className="mobile-col col-12 social-login text-center">
                  <LoginG
                    setExecuting={() => {
                      this.setState({ isLoading: !this.state.isLoading });
                    }}
                    stay={true}
                  />
                </p>
                <div className="login-or mt-30">
                  <span
                    style={{
                      backgroundColor: "#e5e5e5",
                      height: 1,
                      marginBottom: 5,
                      marginTop: 0,
                      display: "block",
                    }}
                  ></span>

                  <span className="span-or">{getDefValues().orLabel}</span>
                </div>

                <Login
                  formData={this.state.formData}
                  toggleF={this.toggleLogin("forgot")}
                  toggleL={this.toggleLogin("login")}
                  toggleR={this.toggleLogin("recovery")}
                  changeHandler={this.changeHandlerL}
                  needLogin={this.state.needLogin}
                  login={this.login}
                  guest={this.guest}
                />
              </MDBModalBody>
            </MDBModal>

            <MDBModal
              isOpen={this.state.modal3}
              toggle={this.toggle(3)}
              fade
              centered
              className="f-modal"
            >
              <MDBModalBody style={{ overflowY: "scroll", maxHeight: 640 }}>
                <p className="flex items-left mt-3">
                  <span className="h3-responsive">
                    {" "}
                    {getDefValues().addSKUstoEventLabel}{" "}
                  </span>
                </p>
                <span
                  style={{
                    backgroundColor: "#e5e5e5",
                    height: 1,
                    marginBottom: 5,
                    marginTop: 0,
                    display: "block",
                  }}
                ></span>

                <div className="row mt-50 mb-30">
                  <div className="col-12 flex items-right">
                    <input
                      className="pagination-search-input"
                      value={this.state.skuToAdd}
                      onChange={this.handleChangeSKU}
                      onKeyDown={this.handleChangeSKU}
                      type="text"
                      name="skuToAdd"
                      placeholder={getDefValues().searchProductLabel}
                    />
                    <button
                      className={"btn btn-secondary btn-sm ml-1"}
                      type="button"
                      style={{ width: "25%" }}
                      onClick={this.addSKUToOrder}
                    >
                      {getDefValues().shortbtnaddbutton}
                    </button>
                  </div>
                </div>
                {this.state.skus.length > 0 ? (
                  <>
                    <div className="row mt-30 row text-left">
                      <div className="col-2"></div>
                      <div className="col-6">SKU</div>
                      <div className="col-2">
                        {getDefValues().shopCartQuantityLabel.toUpperCase()}
                      </div>
                      <div className="col-2"></div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                {this.state.skus.map((item) => (
                  <div className="row flex middle items-left">
                    <div className="col-2">
                      <img
                        alt={item.productname}
                        src={getImagePath(item.image)}
                        className="card-img-top"
                      />
                    </div>
                    <div className="col-6">
                      <b>{item.sku}</b>
                    </div>
                    <div className="col-2">
                      <div className="flex col-text-quantity">
                        <div className="detail-qty-shopcart">
                          <button
                            name={"decrease__" + item.sku}
                            onClick={this.updateEventList2}
                            className="qty-down"
                          >
                            <i className="fas fa-minus"></i>
                          </button>
                          <input
                            type="text"
                            className="qty-val"
                            name={"quantity__" + item.sku}
                            value={
                              item.prequantity != null
                                ? item.prequantity
                                : item.quantity
                            }
                          />
                          <button
                            name={"increase__" + item.sku}
                            onClick={this.updateEventList2}
                            className="qty-up"
                          >
                            <i className="fas fa-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="col-2">
                      <a
                        name={item.sku}
                        onClick={() => this.delSku(item.sku)}
                        className="text-muted"
                      >
                        <img
                          className="icon-trash"
                          src={getImagePath("/catalog/images/ico_trash.svg")}
                          alt="delete-product"
                          width="20px"
                          height="20px"
                        />
                      </a>
                    </div>
                  </div>
                ))}

                {this.state.skus.length > 0 ? (
                  <>
                    <Form
                      formData={this.state.externalOrderFormData}
                      formConfig={this.state.externalOrderFormConfig}
                      changeHandler={this.changeHandlerD}
                    />
                    <div className="row mt-3 mb-3">
                      <div className="col-12 text-center">
                        <button
                          className={"btn btn-secondary btn-sm"}
                          type="button"
                          onClick={this.registerOrder}
                        >
                          {getDefValues().setOrderLabel}
                        </button>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </MDBModalBody>
            </MDBModal>

            <div className="page-wrapper" onClick={this.props.hideCart}>
              {this.state.redirectProductDetails ? (
                <Redirect
                  to={{
                    pathname:
                      (this.state.selectedCategory
                        ? "/" + this.state.selectedCategory + "/"
                        : "/productDetails/") +
                      this.state.selectedProductID +
                      "/" +
                      (this.state.selectedPath
                        ? this.state.selectedPath
                        : "show"),
                  }}
                />
              ) : (
                ""
              )}

              <div className="content-2 container-page container-fluid custom-container">
                <div className="row flex items-center">
                  <div className="col-md-12 col-lg-9 col-lx-7">
                    <div className="row mt-30">
                      <div className="col-12 text-right">
                        <a
                          href="/customer/event/create-event"
                          className="btn btn-sm btn-secondary"
                        >
                          {getDefValues().createNewEventLabel.toUpperCase()}
                        </a>
                      </div>
                    </div>

                    {this.state.moreEvents && (
                      <div className="row mt-2 mb-20">
                        <div className="col-12 text-right">
                          <button
                            className={"btn btn-sm btn-secondary"}
                            type="button"
                            onClick={() => {
                              this.setState({ showEvents: true });
                            }}
                          >
                            {" " +
                              getDefValues().showOtherEvents.toUpperCase() +
                              " "}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row flex items-center">
                  <div className="col-md-12 col-lg-9 col-lx-7">
                    <EventMessage
                      modal={this.state.modal2}
                      toggle={this.toggle(2)}
                      toggleI={this.changePanel(1)}
                      toggleL={this.changePanel(2)}
                      eventimage={this.state.eventimage}
                      eventdate={this.state.eventdate2}
                      eventname={this.state.eventname}
                      eventperson={this.state.eventperson}
                      eventmessage={this.state.eventmessage}
                      setEventMode={this.props.setEventMode}
                      shareUrl={this.state.shareUrl}
                      copyTextToClipboard={this.copyTextToClipboard}
                      isCopied={this.state.isCopied}
                      toggleMoreUrl={this.toggleMoreUrl}
                      showMoreUrl={this.state.showMoreUrl}
                      shareEvent={this.shareEvent}
                    />

                    <div className="row mt-30">
                      <div className="col-12">
                        <div className="steps-form-2">
                          <div
                            style={{
                              width: "100%",
                              marginLeft: 0,
                              display: "flex",
                            }}
                            className="steps-row"
                          >
                            <div
                              className="steps-step"
                              style={{ display: "inline-block", width: "50%" }}
                            >
                              <MDBBtn
                                onClick={this.changePanel(1)}
                                className={
                                  "btn btn-" +
                                  (this.state.formstep === 1
                                    ? "primary"
                                    : "light") +
                                  " cbtn-circle"
                                }
                              >
                                <div
                                  className={
                                    "cbtn-circle-" +
                                    (this.state.formstep === 1
                                      ? "active"
                                      : "inactive")
                                  }
                                ></div>
                              </MDBBtn>
                              <p>
                                {getDefValues().myEventFormLabel.toUpperCase()}
                              </p>
                            </div>
                            <div
                              className="steps-step"
                              style={{ display: "inline-block", width: "50%" }}
                            >
                              <MDBBtn
                                onClick={this.changePanel(2)}
                                className={
                                  "btn btn-" +
                                  (this.state.formstep === 2
                                    ? "primary"
                                    : "light") +
                                  " cbtn-circle"
                                }
                              >
                                <div
                                  className={
                                    "cbtn-circle-" +
                                    (this.state.formstep === 2
                                      ? "active"
                                      : "inactive")
                                  }
                                ></div>
                              </MDBBtn>
                              <p>
                                {getDefValues().eventShopTitle.toUpperCase()}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {this.state.formstep === 1 ? (
                      <div className="card ">
                        {Object.keys(this.state).map((obj) => (
                          <>
                            {obj.startsWith("RENDEROBJ") &&
                              !this.state.modal2 &&
                              !this.state.isLoading ? (
                              <>
                                {this.state[obj].type === "FORM" ? (
                                  <Form
                                    name={this.state[obj].ObjectName}
                                    container={this.state[obj].ObjectName}
                                    formData={this.state[obj].data}
                                    activeForm={this.state[obj].activeForm}
                                    changeForm={this.changeForm}
                                    changeHandler={this.changeHandler}
                                    manageButton={this.manageButton}
                                    formConfig={this.state[obj].config}
                                    lockform={this.state.lockform}
                                    editForm={this.editForm}
                                  />
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.formstep === 2 ? (
                      <>
                        <EventProductsInfo
                          toggle={this.toggle(3)}
                          isLoading={this.state.isLoading}
                          eventInfo={this.state.eventInfo}
                          resumeStyle={this.state.resumeStyle}
                          orders={this.state.orders}
                          products={
                            !this.state.modal2
                              ? this.state.eventListInfo.products
                              : []
                          }
                          updateEventList={this.updateEventList}
                          getTokenEventlist={this.getTokenEventlist}
                          addSkus={this.addSkus}
                          eventid={this.state.eventid}
                          token={this.state.token}
                          refreshEventProducts={this.refreshEventProducts}
                        />
                        {/*
											<h6 className="mt-30"> 
												{getDefValues().addEventProductsMessage}
											</h6>
											*/}
                        <div className="mt-20">
                          {!this.state.isLoading &&
                            Object.keys(this.state).map((obj) => (
                              <>
                                {obj.startsWith("2RENDEROBJ") &&
                                  !this.state.modal2 &&
                                  !this.state.isLoading ? (
                                  <>
                                    {this.state[obj].type === "TEXT" ? (
                                      <Text
                                        name={this.state[obj].ObjectName}
                                        textData={this.state[obj].data}
                                        textConfig={this.state[obj].config}
                                      />
                                    ) : (
                                      ""
                                    )}
                                    {this.state[obj].type === "IMAGE" ? (
                                      <Image
                                        name={this.state[obj].ObjectName}
                                        imageData={this.state[obj].data}
                                        imageConfig={this.state[obj].config}
                                      />
                                    ) : (
                                      ""
                                    )}
                                    {this.state[obj].type === "VIDEO" ? (
                                      <Video
                                        name={this.state[obj].ObjectName}
                                        videoData={this.state[obj].data}
                                        videoConfig={this.state[obj].config}
                                      />
                                    ) : (
                                      ""
                                    )}
                                    {this.state[obj].type ===
                                      "CARDCONTAINER" ? (
                                      <Card
                                        name={this.state[obj].ObjectName}
                                        cardData={this.state[obj].data}
                                        cardConfig={this.state[obj].config}
                                      />
                                    ) : (
                                      ""
                                    )}

                                    {this.state[obj].type === "CARACOL" ? (
                                      <Caracol
                                        name={this.state[obj].ObjectName}
                                        caracolData={this.state[obj].data}
                                        caracolConfig={this.state[obj].config}
                                      />
                                    ) : (
                                      ""
                                    )}
                                    {this.state[obj].type === "SLIDERIMAGE" ? (
                                      <SliderImage
                                        sliderData={this.state[obj].data}
                                        sliderConfig={this.state[obj].config}
                                      />
                                    ) : (
                                      ""
                                    )}
                                    {this.state[obj].type === "SLIDER" ||
                                      this.state[obj].type ===
                                      "SLIDERCONTAINER" ? (
                                      <Slider
                                        name={this.state[obj].ObjectName}
                                        sliderData={this.state[obj].data}
                                        sliderConfig={this.state[obj].config}
                                      />
                                    ) : (
                                      ""
                                    )}
                                    {this.state[obj].type === "BUTTON" ? (
                                      <Button
                                        name={this.state[obj].ObjectName}
                                        buttonData={this.state[obj].data}
                                        buttonConfig={this.state[obj].config}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            ))}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      }
    }
  }
}
export default page;
